<template>
  <router-view />
</template>
<script>
export default {
  name: 'PmAkademi',
};
</script>
